export const styles = theme => ({
    title: {
        "& h3": {
            margin: "1.5rem 0",
        },
        "& h4": {
            margin: "1rem 0"
        },
        margin: "2rem 0",
    },
    subTitle: {
        margin: "1rem 0"
    },
    summary: {
        padding: 0
    },
    details: {
        padding: 0
    },
    productName: {
        fontWeight: 600
    }
});
